var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M17.0007 2.83301C13.289 2.83301 10.2715 5.85051 10.2715 9.56217C10.2715 13.203 13.119 16.1497 16.8307 16.2772C16.944 16.263 17.0573 16.263 17.1423 16.2772C17.1707 16.2772 17.1848 16.2772 17.2132 16.2772C17.2273 16.2772 17.2273 16.2772 17.2415 16.2772C20.8682 16.1497 23.7157 13.203 23.7298 9.56217C23.7298 5.85051 20.7123 2.83301 17.0007 2.83301Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.1973 20.0456C20.2448 17.4106 13.799 17.4106 9.81818 20.0456C8.01901 21.2498 7.02734 22.8789 7.02734 24.6214C7.02734 26.3639 8.01901 27.9789 9.80401 29.1689C11.7873 30.5006 14.394 31.1664 17.0007 31.1664C19.6073 31.1664 22.214 30.5006 24.1973 29.1689C25.9823 27.9648 26.974 26.3498 26.974 24.5931C26.9598 22.8506 25.9823 21.2356 24.1973 20.0456Z",
    fill: "#292D32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9ba426c2bb9df638f5f8253362aaf38e.svg";
export { ForwardRef as ReactComponent };